<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body text-center">
              <div class="mb-3">
                <img
                src="@/assets/images/users/avatar-1.jpg"
                class="mr-3 rounded-circle avatar-xl"
                alt="user-pic"
                />
              </div>
            <div>
                <button class="btn btn-light mr-2"> <i class="fas fa-edit mr-2"></i>
                  <span class="d-none d-sm-inline-block">
                    Edit profile
                  </span>
                </button>
                  <button class="btn btn-light"> <i class="fas fa-edit mr-2"></i>
                  <span class="d-none d-sm-inline-block">
                    Edit Images
                  </span>
                </button>
            </div>
            <div class="pt-4">
                <table class="table-profile table text-left">
                    <thead>
                        <tr>
                            <td width="30%"><b>Name</b></td>
                            <td width="70%">Firman Bachtiar</td>
                        </tr>
                         <tr>
                            <td width="30%"><b>Alias</b></td>
                            <td width="70%">Firman </td>
                        </tr>
                         <tr>
                            <td width="30%"><b>NIK</b></td>
                            <td width="70%">{{nik}}</td>
                        </tr>
                         <tr>
                            <td width="30%"><b>NKK</b></td>
                            <td width="70%">5144145234325</td>
                        </tr>
                         <tr>
                            <td width="30%"><b>Birth place</b></td>
                            <td width="70%">Magelang</td>
                        </tr>
                       <tr>
                            <td width="30%"><b>Date of Birth</b></td>
                            <td width="70%">1992, Feb 21</td>
                        </tr>
                        <tr>
                            <td width="30%"><b>Religion</b></td>
                            <td width="70%">Islam</td>
                        </tr>
                         <tr>
                            <td width="30%"><b>Risk Index</b></td>
                            <td width="70%">N/A</td>
                        </tr>
                         <tr>
                            <td width="30%"><b>Classification</b></td>
                            <td width="70%">Judi Togel</td>
                        </tr>
                    </thead>
                </table>
            </div>
          </div>
        </div>
      </div>
    
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="crypto-buy-sell-nav-content p-4" nav-class="nav-tabs-custom">
                <b-tab title="Contact" active>
                    <div class="card">
                        <div class="table-responsive mb-4">
                            <table class="table table-bordered">
                            <thead>
                                <tr class="text-left">
                                <th colspan="3">
                                    <div class="row">
                                      <div class="col-sm-6 mt-1">
                                           <i class="fas fa-envelope mr-1"></i> Data Email
                                      </div>
                                      <div class="col-sm-6 text-right">
                                          <b-button @click="showModalEmail=true" class="btn btn-sm btn-success">
                                               <i class="fas fa-plus"></i>
                                          </b-button>
                                      </div>
                                    </div>
                                </th>
                                </tr>
                                <tr>
                                <th scope="col">Email</th>
                                <th scope="col"  width="50%">Source</th>
                                <th scope="col" class="text-right" width="10%">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>firman.alay@gmail.com</td>
                                <td>google</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                                <tr>
                                <td>firman.alay@gmail.com</td>
                                <td>google</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>

                        <div class="table-responsive mb-4">
                            <table class="table table-bordered">
                            <thead>
                                <tr class="text-left">
                                <th colspan="3">
                                 <div class="row">
                                      <div class="col-sm-6 mt-1">
                                           <i class="fas fa-phone mr-1"></i> Phone
                                      </div>
                                      <div class="col-sm-6 text-right">
                                         <b-button @click="showModalPhone=true" class="btn btn-sm btn-success">
                                               <i class="fas fa-plus"></i>
                                          </b-button>
                                      </div>
                                    </div>
                                </th>
                                </tr>
                                <tr>
                                <th scope="col">Phone Number</th>
                                <th scope="col" width="50%">Source</th>
                                <th scope="col" class="text-right" width="10%">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>087263553646</td>
                                <td>google</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                                <tr>
                                <td>087263553646</td>
                                <td>google</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>

                         <div class="table-responsive mb-4">
                            <table class="table table-bordered">
                            <thead>
                                <tr class="text-left">
                                <th colspan="3">
                                     <div class="row">
                                      <div class="col-sm-6 mt-1">
                                           <i class="fas fa-home mr-1"></i> Address
                                      </div>
                                      <div class="col-sm-6 text-right">
                                          <b-button @click="showModalAddress=true" class="btn btn-sm btn-success">
                                               <i class="fas fa-plus"></i>
                                          </b-button>
                                      </div>
                                    </div>
                                </th>
                                </tr>
                                <tr>
                                <th scope="col">Nomer Telephone</th>
                                <th scope="col" width="50%">Source</th>
                                <th scope="col" class="text-right" width="10%">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>Magelang City, blok 4, No.666</td>
                                <td>google</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                                <tr>
                                <td>Magelang City, blok 4, No.666</td>
                                <td>google</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                </b-tab>
                <b-tab title="Family">
                   <div class="card">
                        <div class="table-responsive mb-4">
                            <table class="table table-bordered">
                            <thead>
                                <tr class="text-left">
                                <th colspan="3">
                                    <div class="row">
                                    <div class="col-sm-6 mt-1">
                                           <i class="fas fa-users mr-1"></i> Family
                                      </div>
                                      <div class="col-sm-6 text-right">
                                          <button class="btn btn-sm btn-success">
                                               <i class="fas fa-plus"></i>
                                          </button>
                                      </div>
                                    </div>
                                </th>
                                </tr>
                                <tr>
                                <th scope="col">Name</th>
                                <th scope="col"  width="50%">Relathionship</th>
                                <th scope="col" class="text-right" width="10%">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>Isyana Syaraswati</td>
                                <td>Istri 1</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                                <tr>
                                <td>Maudy Ayuda</td>
                                <td>Istri 2</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
              </b-tab>
                <b-tab title="Career">
                   <div class="card">
                        <div class="table-responsive mb-4">
                               <table class="table table-bordered">
                            <thead>
                                <tr class="text-left">
                                <th colspan="5">
                                 <div class="row">
                                    <div class="col-sm-6 mt-1">
                                           <i class="fas fa-home mr-1"></i> Education
                                      </div>
                                      <div class="col-sm-6 text-right">
                                          <button class="btn btn-sm btn-success">
                                               <i class="fas fa-plus mr-1"></i>
                                          </button>
                                      </div>
                                    </div>
                                </th>
                                </tr>
                                <tr>
                                <th scope="col" width="25%">Institution</th>
                                <th scope="col" width="10%">Years</th>
                                <th scope="col" width="20%">Position</th>
                                <th scope="col">Description</th>
                                <th scope="col" class="text-right" width="10%">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>Unikom</td>
                                <td>2018</td>
                                <td>Visual Desain</td>
                                <td>IPK. 3.7</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>

                        <div class="table-responsive mb-4">
                            <table class="table table-bordered">
                            <thead>
                                <tr class="text-left">
                                <th colspan="5">
                                    <div class="row">
                                    <div class="col-sm-6 mt-1">
                                           <i class="fas fa-home mr-1"></i> Employee
                                      </div>
                                      <div class="col-sm-6 text-right">
                                          <button class="btn btn-sm btn-success">
                                               <i class="fas fa-plus"></i>
                                          </button>
                                      </div>
                                    </div>
                                </th>
                                </tr>
                                <tr>
                                <th scope="col" width="25%">Institution</th>
                                <th scope="col" width="10%">Years</th>
                                <th scope="col" width="20%">Position</th>
                                <th scope="col">Description</th>
                                <th scope="col" class="text-right" width="10%">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>Xyber</td>
                                <td>2021</td>
                                <td>Media</td>
                                <td>..</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>

                         <div class="table-responsive mb-4">
                            <table class="table table-bordered">
                            <thead>
                                <tr class="text-left">
                                <th colspan="5">
                                    <div class="row">
                                        <div class="col-sm-6 mt-1">
                                           <i class="fas fa-users mr-1"></i> Organization
                                        </div>
                                        <div class="col-sm-6 text-right">
                                          <button class="btn btn-sm btn-success">
                                               <i class="fas fa-plus"></i>
                                          </button>
                                        </div>
                                    </div>
                                </th>
                                </tr>
                                <tr>
                                <th scope="col" width="25%">Organization</th>
                                <th scope="col" width="10%">Years</th>
                                <th scope="col" width="20%">Position</th>
                                <th scope="col">Description</th>
                                <th scope="col" class="text-right" width="10%">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>Supreme Magelang</td>
                                <td>2021</td>
                                <td>CEO</td>
                                <td>.</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
              </b-tab>
                <b-tab title="Social Media">
                   <div class="card">
                        <div class="table-responsive mb-4">
                            <table class="table table-bordered">
                            <thead>
                                <tr class="text-left">
                                <th colspan="3">
                                    <div class="row">
                                    <div class="col-sm-6 mt-1">
                                           <i class="fas fa-star mr-1"></i> Social Media
                                      </div>
                                      <div class="col-sm-6 text-right">
                                          <button class="btn btn-sm btn-success">
                                               <i class="fas fa-plus"></i>
                                          </button>
                                      </div>
                                    </div>
                                </th>
                                </tr>
                                <tr>
                                <th scope="col">Account</th>
                                <th scope="col"  width="50%">Platfrom</th>
                                <th scope="col" class="text-right" width="10%">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>Firman 123</td>
                                <td>Instagram</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                                <tr>
                                <td>Firman Bahtiar</td>
                                <td>Facebook</td>
                                <td class="text-right"><button class="btn btn-light btn-sm"><i class="fas fa-edit"></i></button> <button class="btn btn-light btn-sm ml-1"><i class="fas fa-trash"></i></button></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                </div>
              </b-tab>
                <b-tab title="Insight">
                  <div class="mb-2">
                    <label>Insight</label>
                  </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>



    <!-- modal -->       
    <b-modal id="create-email" size="l" v-model="showModalEmail" :title="'Add Email : '+ nik" title-class="font-18" hide-footer>
      <form>
        <div class="row">
          <p>{{formEmail}}</p>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="email">Email</label>
              <input
                type="email"
                class="form-control"
                id="email"
                v-model="formEmail.email"
                placeholder="Email"
              />
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="source">Source</label>
              <input
                type="text"
                class="form-control"
                id="source"
                v-model="formEmail.source"
                placeholder="Source"
              />
            </div>
          </div>
          <div class="col-lg-12 text-right">
            <div class="form-group">
             <b-button class="btn btn-sm btn-secondary px-2 mr-1" @click="showModalEmail=false">Cancel</b-button> 
             <button class="btn btn-sm btn-success px-3" @click="addEmail">Save</button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal id="create-phone" size="l" v-model="showModalPhone" :title="'Add Phone : '+ nik" title-class="font-18" hide-footer>
      <form>
        <div class="row">
          <p>{{formPhone}}</p>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="Phone">Phone</label>
              <input
                type="text"
                class="form-control"
                id="Phone"
                v-model="formPhone.phone_number"
                placeholder="Phone"
              />
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="source">Source</label>
              <input
                type="text"
                class="form-control"
                id="source"
                v-model="formPhone.source"
                placeholder="Source"
              />
            </div>
          </div>
          <div class="col-lg-12 text-right">
            <div class="form-group">
                <b-button class="btn btn-sm btn-secondary px-2 mr-1" @click="showModalPhone=false">Cancel</b-button> 
                <button class="btn btn-sm btn-success px-3" @click="addPhone">Save</button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

     <b-modal id="create-address" size="l" v-model="showModalAddress" :title="'Add Address : '+ nik" title-class="font-18" hide-footer>
      <form>
        <div class="row">
          <p>{{formAddress}}</p>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="address">Address</label>
              <input
                type="text"
                class="form-control"
                id="address"
                v-model="formAddress.address"
                placeholder="Address"
              />
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="source">Source</label>
              <input
                type="text"
                class="form-control"
                id="source"
                v-model="formAddress.source"
                placeholder="Source"
              />
            </div>
          </div>
          <div class="col-lg-12 text-right">
            <div class="form-group">
                <b-button class="btn btn-sm btn-secondary px-2 mr-1" @click="showModalAddress=false">Cancel</b-button> 
                <button class="btn btn-sm btn-success px-3" @click="addAddress">Save</button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Profile component
 */
export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      showModalAddress: false,
      showModalEmail: false,
      showModalPhone: false,
      nik: this.$route.params.nik,
      title: "Profile",
      formEmail:{
        email:'',
        source:'',
      },
      formPhone:{
        phone_number:'',
        source:'',
      },
      formAddress:{
        address:'',
        source:'',
      },
      items: [
        {
          text: "Home",
          href: "/"
        },
         {
          text: "Personal Database",
          href: "/personal-database"
        },
        {
          text: "Detail Profile",
          active: true
        }
      ]
    };
  },
  methods: {
    addEmail(){
      console.log('data:', this.formEmail)
    },
     addPhone(){
      console.log('data:', this.formPhone)
    },
     addAddress(){
      console.log('data:', this.formAddress)
    }
  },
};
</script>

<style lang="scss" scoped>
.table-profile{
    font-size: 14px;
}
</style>